import { EVENT_ACTIONS, EVENT_CATEGORIES } from 'constants/tracking'

export enum CommonGTMEvents {
  SIMULATION_STARTED = 'simulation_started',
  PRODUCER_CONTACT_CLICKED = 'producer_contact_click'
}

export enum CampaignGTMEvents {
  TELESALES_CLICK = 'telesales_click'
}

export enum CommonTrackingParams {
  CAMPAIGN = 'campaign',
  CUSTOMER_TYPE = 'customer_type',
  FROM_PAGE = 'from_page',
  PORTAL_CONFIRMATION = 'portal_confirmation',
  SELECTED_PRODUCT = 'selected_product',
  SIMULATION_TYPE = 'simulation_type',
  STEP = 'step',
  SIGN_CHANNEL = 'sign_channel'
}

export type EventCategory = (typeof EVENT_CATEGORIES)[keyof typeof EVENT_CATEGORIES] // describes the context the event took place in
export type EventObject = string // (snake_case) noun refers to the component or location the event took place in
export type EventAction = (typeof EVENT_ACTIONS)[keyof typeof EVENT_ACTIONS] // verb that describes what happened

export type TrackingEvent = {
  action: EventAction
  category: EventCategory
  object?: EventObject
}

export type EventNameFormat = `${EventCategory}:${EventObject}_${EventAction}` | `${EventCategory}:${EventAction}`
